import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IDocumentType } from 'src/app/models/interfaces/document-type.interface';

export class DocumentTypeDetailContext extends DefaultDetailContext<IDocumentType, number> {}
